import { section } from "@/neon";

import productItem from "@/components/productItem";
import scrollIntoView from "@/lib/scrollIntoView";
import carousel from "@/components/carousel";

const slideshowOpts = {
  prevNextButtons: false,
  adaptiveHeight: false,
  pageDots: false,
  cellAlign: "left",
};

const selectors = {
  section: "product-recommendations",
  innerContainer: ".product-recommendations__inner",
  productsContainer: ".product-recommendations__products",
  products: ".product-item",
};

section("product-recommendations", {
  onLoad() {
    this._getProductRecommendations();

    this.scrollAnimation = scrollIntoView(this.container);
  },

  _getProductRecommendations() {
    const { sectionId, productId, limit } = this.container.dataset;

    // Build request URL
    var requestUrl = `${window.theme.routes.productRecommendations}?section_id=${sectionId}&limit=${limit}&product_id=${productId}`;

    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();

    request.open("GET", requestUrl, true);

    request.onload = () => {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        this.container.innerHTML = container.querySelector(
          ".product-recommendations"
        ).innerHTML;

        this._initProductItems();
        this._initSlider();
      }
    };
    request.send();
  },

  _initProductItems() {
    const products = this.container.querySelectorAll(selectors.products);
    this.productItems = [];

    products.forEach(element => {
      this.productItems.push(productItem(element));
    });
  },

  _initSlider() {
    this.carousel = carousel(this.container);
  },

  onUnload() {
    this.productItems.forEach(item => item.unload());
    this.carousel.unload();
  },
});
